import React from 'react';
import './stars.scss';

export default function Stars() {
  return (
    <section className="wrapper h-0">
      <div id="stars" />
      <div id="stars2" />
      <div id="stars3" />
    </section>
  );
}
